var _excluded = ["children", "className", "direction", "textStyle", "fontWeight", "href", "icon", "tag", "variant"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
require("./index.css");
var styles = {
  "link": "link-2SfIB",
  "linkContent": "linkContent-LoBth",
  "linkArrowUnderline": "linkArrowUnderline-BOGbX",
  "linkUnderline": "linkUnderline-1xT1Q",
  "linkUnderlineAnimated": "linkUnderlineAnimated-17iIG",
  "linkIcon": "linkIcon-7Vlhb",
  "arrowIcon": "arrowIcon-1xhph",
  "arrowIconRight": "arrowIconRight-YcXve",
  "arrowIconLeft": "arrowIconLeft-2EH6Q",
  "left": "left-1G97E"
};
import { rightLinkArrowIcon } from '@lululemon/ecom-pattern-library-icons';
import LinkGenerator from '../link-generator';
import Icon from '../icons';
var Link = _ref => {
  var {
      children,
      className,
      direction,
      textStyle,
      fontWeight,
      href,
      icon,
      tag,
      variant
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  var hasIcon = !!icon;
  var isArrowVariant = variant === 'arrowBold' || variant === 'arrowUnderline';
  var getIcon = () => {
    if (!hasIcon && !isArrowVariant) {
      return;
    } else if (hasIcon) {
      return /*#__PURE__*/React.createElement(Icon, {
        content: icon,
        "aria-hidden": "true",
        "data-testid": "link-icon",
        className: cn(styles.linkIcon)
      });
    } else if (!hasIcon && isArrowVariant) {
      return /*#__PURE__*/React.createElement(Icon, {
        className: cn(styles.linkIcon, styles.arrowIcon, {
          [styles.left]: direction === 'left'
        }),
        content: rightLinkArrowIcon,
        "aria-hidden": "true",
        "data-testid": "link-icon__arrow"
      });
    }
  };
  var Tag = tag || 'a';
  var iconComponent = getIcon();
  var linkContent = /*#__PURE__*/React.createElement("span", {
    className: styles.linkContent
  }, children);
  var classes = cn(styles.link, className, {
    [styles.linkUnderline]: variant === 'underline',
    [styles.linkUnderlineAnimated]: variant === 'underlineAnimated',
    [styles.linkArrowBold]: variant === 'arrowBold',
    [styles.linkArrowUnderline]: variant === 'arrowUnderline',
    [styles.arrowIconRight]: direction === 'right',
    [styles.arrowIconLeft]: direction === 'left'
  });
  var textStyling = "lll-text-".concat(textStyle, " \n  ").concat(variant === 'arrowBold' && 'lll-font-weight-semibold', " \n  ").concat(fontWeight === 'medium' && 'lll-font-weight-medium');
  return /*#__PURE__*/React.createElement(Tag, _extends({
    href: href,
    className: "".concat(textStyling, " ").concat(classes)
  }, rest), direction !== 'right' && iconComponent, linkContent, direction === 'right' && iconComponent);
};
Link.propTypes = {
  children: PropTypes.node.isRequired,
  /* choose a classname */
  className: PropTypes.string,
  /** indicates the direction of the link */
  direction: PropTypes.oneOf(['left', 'right', undefined]),
  textStyle: PropTypes.oneOf(['body-1', 'body-2', 'body-3']),
  fontWeight: PropTypes.oneOf(['regular', 'medium']),
  href: PropTypes.string,
  icon: PropTypes.svg,
  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
  variant: PropTypes.oneOf(['underline', 'arrowBold', 'arrowUnderline', 'underlineAnimated'])
};
Link.defaultProps = {
  className: null,
  direction: undefined,
  textStyle: 'body-2',
  fontWeight: 'regular',
  href: null,
  icon: null,
  tag: LinkGenerator,
  variant: 'underline'
};
export default Link;